import { Texture } from '@seddi/three';

import { isMobile } from '@/core/platform';

export function configure() {
  if (!isMobile()) {
    Texture.DEFAULT_ANISOTROPY = 4;
  }
}
